import './Header.scss';
import Component from './Header.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);